export default {"src":"/_next/static/media/icon-support.0238fd51.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};